import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/layout/main.vue'
import Empty from '@/components/layout/empty.vue'

Vue.use(Router)

const mainchild = [{
    path: 'home',
    title: '首页',
    name: 'home_index',
    component: resolve => {
      require(['@/view/home/home.vue'], resolve)
    }
  },
  {
    path: 'navigator',
    title: '导航',
    name: 'navigator',
    component: resolve => {
      require(['@/view/home/navigator.vue'], resolve)
    }
  },
  {
    path: 'querymysqlperm',
    name: 'querymysqlperm',
    title: 'Mysql查询申请',
    'icon': 'ios-podium',
    component: resolve => {
      require(['@/view/query/workFlowMysql.vue'], resolve)
    }
  },
  {
    path: 'querymysqlready',
    title: 'Mysql查询申请进度',
    name: 'querymysqlready',
    component: resolve => {
      require(['@/view/query/submitMysqlPage.vue'], resolve)
    }
  },
  {
    path: 'querymysqlpage',
    title: '查询Mysql',
    name: 'querymysqlpage',
    component: resolve => {
      require(['@/view/query/queryMysql.vue'], resolve)
    }
  },
  {
    path: 'querymongoready',
    title: '查询申请进度',
    name: 'querymongoready',
    component: resolve => {
      require(['@/view/query/submitMongoPage.vue'], resolve)
    }
  },
  {
    path: 'querymongoperm',
    name: 'querymongoperm',
    title: 'MongoDB查询申请',
    'icon': 'ios-podium',
    component: resolve => {
      require(['@/view/query/workFlowMongo.vue'], resolve)
    }
  },
  {
    path: 'querymongopage',
    title: '查询MongoDB',
    name: 'querymongopage',
    component: resolve => {
      require(['@/view/query/queryMongo.vue'], resolve)
    }
  },
  {
    path: 'queryredisready',
    title: '查询申请进度',
    name: 'queryredisready',
    component: resolve => {
      require(['@/view/query/submitRedisPage.vue'], resolve)
    }
  },
  {
    path: 'queryredisperm',
    name: 'queryredisperm',
    title: 'Redis查询申请',
    'icon': 'ios-podium',
    component: resolve => {
      require(['@/view/query/workFlowRedis.vue'], resolve)
    }
  },
  {
    path: 'queryredispage',
    title: '查询Redis',
    name: 'queryredispage',
    component: resolve => {
      require(['@/view/query/queryRedis.vue'], resolve)
    }
  },
  {
    path: 'querykafkaperm',
    name: 'querykafkaperm',
    title: 'Kafka查询申请',
    'icon': 'ios-podium',
    component: resolve => {
      require(['@/view/query/workFlowKafka.vue'], resolve)
    }
  },
  {
    path: 'querykafkapage',
    title: '查询Kafka',
    name: 'querykafkapage',
    component: resolve => {
      require(['@/view/query/queryKafka.vue'], resolve)
    }
  },
  {
    path: 'querylist',
    title: '查询审计详情',
    name: 'querylist',
    component: resolve => {
      require(['@/view/audit/expend.vue'], resolve)
    }
  },
  {
    path: 'orderlist',
    title: '工单详情',
    name: 'orderlist',
    component: resolve => {
      require(['@/view/order/components/myorderList.vue'], resolve)
    }
  },
  {
    path: 'myorder',
    name: 'myorder',
    title: '我的工单',
    icon: 'person',
    component: resolve => {
      require(['@/view/order/myOrder.vue'], resolve)
    }
  },
  {
    path: 'deployment',
    title: '部署详情信息',
    name: 'deployment',
    component: resolve => {
      require(['@/view/clusters/deployment.vue'], resolve);
    }
  },
  {
    path: 'statefulset',
    title: '有状态详情信息',
    name: 'statefulset',
    component: resolve => {
      require(['@/view/clusters/statefulset.vue'], resolve);
    }
  },
  {
    path: 'daemonset',
    title: '守护进程集详情信息',
    name: 'daemonset',
    component: resolve => {
      require(['@/view/clusters/daemonset.vue'], resolve);
    }
  },
  {
    path: 'pod',
    title: '容器组详情信息',
    name: 'pod',
    component: resolve => {
      require(['@/view/clusters/pod.vue'], resolve);
    }
  },
  {
    path: 'job',
    title: '任务详情信息',
    name: 'job',
    component: resolve => {
      require(['@/view/clusters/job.vue'], resolve);
    }
  },
  {
    path: 'cronjob',
    title: '定时任务详情信息',
    name: 'cronjob',
    component: resolve => {
      require(['@/view/clusters/cronjob.vue'], resolve);
    }
  },
  {
    path: 'service',
    title: '服务详情信息',
    name: 'service',
    component: resolve => {
      require(['@/view/clusters/service.vue'], resolve);
    }
  },
  {
    path: 'create_secret',
    title: '创建保密字典',
    name: 'create_secret',
    component: resolve => {
      require(['@/view/clusters/components/create_secret.vue'], resolve);
    }
  },
  {
    path: '/cmdb/domain',
    title: '资产网域',
    name: 'assets_domain',
    component: resolve => {
      require(['@/view/cmdb/domain.vue'], resolve);
    }
  },
  {
    path: '/app/info',
    title: '应用信息',
    name: 'appInfo',
    component: resolve => {
      require(['@/view/cicd/app.vue'], resolve);
    }
  },
  {
    path: '/project/dp',
    title: '无状态应用详情信息',
    name: 'dp',
    component: resolve => {
      require(['@/view/project/deployment.vue'], resolve);
    }
  },
  {
    path: '/project/st',
    title: '有状态应用详情信息',
    name: 'st',
    component: resolve => {
      require(['@/view/project/statefulset.vue'], resolve);
    }
  },
  {
    path: '/project/pd',
    title: '容器组详情信息',
    name: 'pd',
    component: resolve => {
      require(['@/view/project/pod.vue'], resolve);
    }
  },
  {
    path: '/project/cjb',
    title: '定时任务详情信息',
    name: 'cjb',
    component: resolve => {
      require(['@/view/project/cronjob.vue'], resolve);
    }
  },
  {
    path: '/project/jb',
    title: '任务详情信息',
    name: 'jb',
    component: resolve => {
      require(['@/view/project/job.vue'], resolve);
    }
  }
]

export const podTerminal = {
  path: '/clusters/application/pod/terminal',
  title: '远程终端',
  name: 'terminal',
  component: resolve => {
    require(['@/view/clusters/podTerminal.vue'], resolve);
  }
}

export const appTerminal = {
  path: '/project/pd/terminal',
  title: '远程终端',
  name: 'appterminal',
  component: resolve => {
    require(['@/view/project/appTerminal.vue'], resolve);
  }
}

export const podLog = {
  path: '/clusters/application/pod/log',
  title: '实时日志',
  name: 'log',
  component: resolve => {
    require(['@/view/clusters/log.vue'], resolve);
  }
}

export const appLog = {
  path: '/project/pd/log',
  title: '实时日志',
  name: 'log',
  component: resolve => {
    require(['@/view/project/appLog.vue'], resolve);
  }
}

export const nodeTerminal = {
  path: '/node/terminal',
  title: '节点远程终端',
  name: 'node-terminal',
  component: resolve => {
    require(['@/view/clusters/nodeTerminal.vue'], resolve);
  }
}

export const creplay = {
  path: '/creplay',
  title: '容器记录回放',
  name: 'creplay',
  component: resolve => {
    require(['@/view/assistantManger/creplay.vue'], resolve);
  }
}

export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: resolve => {
    require(['@/view/login/login.vue'], resolve)
  }
}

export const passwordRouter = {
  path: '/password',
  name: 'password',
  meta: {
    title: 'password - 密码修改'
  },
  component: resolve => {
    require(['@/view/password/password.vue'], resolve)
  }
}

export const page401 = {
  path: '/401',
  meta: {
    title: '401-权限不足'
  },
  name: 'error_401',
  component: resolve => {
    require(['@/view/error/401.vue'], resolve)
  }
}

export const appRouter = [{
    path: '/',
    icon: 'md-home',
    name: 'main',
    title: '首页',
    component: Index,
    redirect: '/home',
    children: [
      ...mainchild
    ]
  },
  {
    path: '/order',
    icon: 'md-folder',
    name: 'order',
    title: '工单提交',
    component: Index,
    children: [{
        path: 'myorder',
        name: 'myorder',
        title: '我的工单',
        icon: 'md-git-merge',
        component: resolve => {
          require(['@/view/order/myOrder.vue'], resolve)
        }
      },
      {
        path: 'sql',
        name: 'ddledit',
        title: 'SQL工单',
        icon: 'md-git-merge',
        meta: {
          keepAlive: true
        },
        component: resolve => {
          require(['@/view/order/ddlOrder.vue'], resolve)
        }
      },
      {
        path: 'ecsorder',
        name: 'ecsorder',
        title: '测试机工单',
        icon: 'md-code',
        meta: {
          keepAlive: true
        },
        component: resolve => {
          require(['@/view/order/ecsOrder.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/view',
    icon: 'md-search',
    name: 'view',
    title: '查询',
    component: Index,
    children: [{
      path: 'serach-mysql',
      name: 'serach-mysql',
      title: 'SQL查询',
      icon: 'ios-podium',
      component: resolve => {
        require(['@/view/query/queryPermsMysql.vue'], resolve)
      }
    },
    {
      path: 'serach-mongodb',
      name: 'serach-mongodb',
      title: 'MongoDB查询',
      icon: 'ios-podium',
      component: resolve => {
        require(['@/view/query/queryPermsMongo.vue'], resolve)
      }
    },
    {
      path: 'serach-redis',
      name: 'serach-redis',
      title: 'Redis查询',
      icon: 'ios-podium',
      component: resolve => {
        require(['@/view/query/queryPermsRedis.vue'], resolve)
      }
    },
    {
      path: 'serach-kafka',
      name: 'serach-kafka',
      title: 'Kafka查询',
      icon: 'ios-podium',
      component: resolve => {
        require(['@/view/query/queryPermsKafka.vue'], resolve)
      }
    },
    {
      path: 'serach-soar',
      name: 'serach-soar',
      title: 'SQL评估优化',
      icon: 'ios-podium',
      component: resolve => {
        require(['@/view/query/soarMysql.vue'], resolve)
      }
    }]
  },
  {
    path: '/clusters',
    icon: 'logo-codepen',
    name: 'clusters',
    title: '容器服务',
    component: Index,
    children: [
      {
        path: 'cluster',
        icon: 'cluster',
        name: 'cluster',
        title: '集群',
        access: 0,
        component: Empty,
        children: [
          {
            path: 'nodes',
            name: 'nodes',
            title: '节点',
            'icon': 'ios-cube-outline',
            component: resolve => {
              require(['@/view/clusters/nodes.vue'], resolve)
            }
          },
          {
            path: 'namespaces',
            name: 'namespaces',
            title: '命名空间',
            'icon': 'ios-appstore-outline',
            component: resolve => {
              require(['@/view/clusters/namespaces.vue'], resolve)
            }
          },
          {
            path: 'events',
            name: 'events',
            title: '事件',
            'icon': 'ios-cube-outline',
            component: resolve => {
              require(['@/view/clusters/events.vue'], resolve)
            }
          }
        ]
      },
      {
      path: 'application',
      icon: 'application',
      name: 'application',
      title: '应用',
      component: Empty,
      children: [
        {
          path: 'deployments',
          name: 'deployments',
          title: '无状态',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/deployments.vue'], resolve)
          }
        },
        {
          path: 'statefulsets',
          name: 'statefulsets',
          title: '有状态',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/statefulsets.vue'], resolve)
          }
        },
        {
          path: 'daemonsets',
          name: 'daemonsets',
          title: '守护进程集',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/daemonsets.vue'], resolve)
          }
        },
        {
          path: 'replicasets',
          name: 'replicasets',
          title: '副本集',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/replicasets.vue'], resolve)
          }
        },
        {
          path: 'jobs',
          name: 'jobs',
          title: '任务',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/jobs.vue'], resolve)
          }
        },
        {
          path: 'cronjobs',
          name: 'cronjobs',
          title: '定时任务',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-cube-outline',
          component: resolve => {
            require(['@/view/clusters/cronjobs.vue'], resolve)
          }
        },
        {
          path: 'pods',
          name: 'pods',
          title: '容器组',
          meta: {
            keepAlive: true
          },
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/pods.vue'], resolve)
          }
        }]
      },
      {
        path: 'router',
        icon: 'router',
        name: 'router',
        title: '路由负载均衡',
        component: Empty,
        children: [
        {
          path: 'services',
          name: 'services',
          title: '服务',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/services.vue'], resolve)
          }
        },
        {
          path: 'endpoints',
          name: 'endpoints',
          title: '端点',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/endpoints.vue'], resolve)
          }
        },
        {
          path: 'ingress',
          name: 'ingress',
          title: '路由',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/ingress.vue'], resolve)
          }
        }
       ]
      },
      {
        path: 'istio',
        icon: 'istio',
        name: 'istio',
        title: '服务网格',
        component: Empty,
        children: [
        {
          path: 'virtualservices',
          name: 'virtualservices',
          title: '虚拟服务',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/virtualservices.vue'], resolve)
          }
        },
        {
          path: 'gateways',
          name: 'gateways',
          title: '服务网关',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/gateways.vue'], resolve)
          }
        }
       ]
      },
      {
        path: 'config',
        icon: 'config',
        name: 'config',
        title: '应用配置',
        component: Empty,
        children: [
        {
          path: 'configmaps',
          name: 'configmaps',
          title: '配置项',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/configmaps.vue'], resolve)
          }
        },
        {
          path: 'secrets',
          name: 'secrets',
          title: '保密字典',
          'icon': 'ios-appstore-outline',
          component: resolve => {
            require(['@/view/clusters/secrets.vue'], resolve)
          }
        }
       ]
      },
      {
        path: 'k8slog',
        name: 'k8slog',
        title: '操作日志',
        access: 0,
        'icon': 'ios-cube-outline',
        component: resolve => {
          require(['@/view/clusters/k8slog.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/project',
    icon: 'md-apps',
    name: 'project',
    title: '项目',
    component: Index,
    children: [{
      path: 'list',
      name: 'list',
      title: '项目列表',
      icon: 'logo-rss',
      access: 0,
      component: resolve => {
        require(['@/view/project/projects.vue'], resolve)
      }
    },
    {
      path: 'env',
      name: 'env',
      title: '环境概览',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/envstatistics.vue'], resolve)
      }
    },
    {
      path: 'dps',
      name: 'dps',
      title: '无状态应用',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/deployments.vue'], resolve)
      }
    },
    {
      path: 'sts',
      name: 'sts',
      title: '有状态应用',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/statefulsets.vue'], resolve)
      }
    },
    {
      path: 'cjbs',
      name: 'cjbs',
      title: '定时任务',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/cronjobs.vue'], resolve)
      }
    },
    {
      path: 'pds',
      name: 'pds',
      title: '容器实例',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/pods.vue'], resolve)
      }
    },
    {
      path: 'svcs',
      name: 'svcs',
      title: '内部域名',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/services.vue'], resolve)
      }
    },
    {
      path: 'domain',
      name: 'domain',
      title: '公网域名',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/ingress.vue'], resolve)
      }
    },
    {
      path: 'chlog',
      name: 'chlog',
      title: '应用日志',
      'icon': 'ios-cube-outline',
      component: resolve => {
        require(['@/view/project/log.vue'], resolve)
      }
    }
    ]
  },
  {
    path: '/cicd',
    icon: 'md-open',
    name: 'cicd',
    title: 'CICD',
    component: Index,
    children: [{
      path: 'cijobs',
      name: 'cijobs',
      title: '发布列表',
      icon: 'logo-rss',
      component: resolve => {
        require(['@/view/cicd/jobs.vue'], resolve)
      }
    },
    {
      path: 'projects',
      name: 'projects',
      title: '项目列表',
      icon: 'logo-rss',
      access: 0,
      component: resolve => {
        require(['@/view/cicd/projects.vue'], resolve)
      }
    },
    {
      path: 'apps',
      name: 'apps',
      title: '应用列表',
      icon: 'logo-rss',
      access: 0,
      component: resolve => {
        require(['@/view/cicd/apps.vue'], resolve)
      }
    }
    ]
  },
  {
    path: '/audit',
    icon: 'md-open',
    name: 'audit',
    title: '审核',
    component: Index,
    access: 0,
    children: [{
      path: 'query-audit',
      name: 'query-audit',
      title: '查询',
      icon: 'logo-rss',
      component: resolve => {
        require(['@/view/audit/queryAudit.vue'], resolve)
      }
    },
    {
        path: 'audit-order',
        name: 'audit-audit',
        title: '工单',
        icon: 'md-create',
        component: resolve => {
          require(['@/view/audit/sqlAudit.vue'], resolve)
        }
      },
      {
        path: 'audit-permissions',
        name: 'audit-permissions',
        title: '权限',
        icon: 'md-share',
        component: resolve => {
          require(['@/view/audit/permissions.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/record',
    icon: 'md-pie',
    name: 'record',
    title: '记录',
    component: Index,
    access: 0,
    children: [{
        path: 'query-review',
        name: 'query-review',
        title: '查询审计',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/assistantManger/queryRecord.vue'], resolve)
        }
      },
      {
        path: 'audit-record',
        name: 'audit-record',
        title: '工单记录',
        icon: 'md-list',
        component: resolve => {
          require(['@/view/assistantManger/record.vue'], resolve)
        }
      },
      {
        path: 'pod-exec-record',
        title: '终端记录',
        name: 'pod-exec-record',
        component: resolve => {
          require(['@/view/assistantManger/podTeminalRecord.vue'], resolve);
        }
      }

    ]
  },
  {
    path: '/cmdb',
    icon: 'md-pie',
    name: 'cmdb',
    title: 'CMDB',
    component: Index,
    access: 0,
    children: [{
        path: 'hosts',
        name: 'hosts',
        title: '主机管理',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/cmdb/hosts.vue'], resolve)
        }
      },
      {
        path: 'domains',
        name: 'domains',
        title: '网域列表',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/cmdb/domains.vue'], resolve)
        }
      },
      {
        path: 'admin-users',
        name: 'admin-users',
        title: '管理用户',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/cmdb/adminUsers.vue'], resolve)
        }
      },
      {
        path: 'system-users',
        name: 'system-users',
        title: '系统用户',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/cmdb/systemUsers.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/dns',
    icon: 'md-pie',
    name: 'dns',
    title: 'DNS',
    component: Index,
    access: 0,
    children: [{
        path: 'dns-list',
        name: 'dns-list',
        title: '域名列表',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/dns/list.vue'], resolve)
        }
      },
      {
        path: 'dns-record',
        name: 'dns-record',
        title: '域名解析',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/dns/record.vue'], resolve)
        }
      },
      {
        path: 'dns-history',
        name: 'dns-history',
        title: '操作记录',
        icon: 'md-pulse',
        component: resolve => {
          require(['@/view/dns/history.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/management',
    icon: 'logo-buffer',
    name: 'management',
    title: '管理',
    access: 0,
    component: Index,
    children: [{
        path: 'management-user',
        name: 'management-user',
        title: '用户',
        icon: 'md-people',
        component: resolve => {
          require(['@/view/management/users.vue'], resolve)
        }
      },
      {
        path: 'management-database',
        name: 'management-database',
        title: '数据库',
        icon: 'md-medal',
        component: resolve => {
          require(['@/view/management/databases.vue'], resolve)
        }
      },
      {
        path: 'management-cluster',
        name: 'management-cluster',
        title: '容器集群',
        'icon': 'logo-codepen',
        component: resolve => {
          require(['@/view/management/clusters.vue'], resolve)
        }
      },
      {
        path: 'setting',
        name: 'setting',
        title: '设置',
        icon: 'md-settings',
        component: resolve => {
          require(['@/view/management/settings.vue'], resolve)
        }
      },
      {
        path: 'auth-group',
        name: 'auth-group',
        title: '权限组',
        icon: 'ios-switch',
        component: resolve => {
          require(['@/view/management/authGroup.vue'], resolve)
        }
      },
      {
        path: 'menu',
        name: 'menu',
        title: '菜单',
        icon: 'ios-switch',
        component: resolve => {
          require(['@/view/management/menu.vue'], resolve)
        }
      },
      {
        path: 'task',
        name: 'task',
        title: '定时任务',
        icon: 'ios-switch',
        component: resolve => {
          require(['@/view/management/task.vue'], resolve)
        }
      }
    ]
  }
]

export const asyncRoutes = []

export const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录'
    },
    component: resolve => {
      require(['@/view/login/login.vue'], resolve)
    }
  },
  {
    path: '/password',
    name: 'password',
    meta: {
      title: 'password - 密码修改'
    },
    component: resolve => {
      require(['@/view/password/password.vue'], resolve)
    }
  },
  {
    path: '/',
    icon: 'md-home',
    name: 'main',
    title: '首页',
    component: Index,
    redirect: '/home',
    children: [
      {
        path: '/home',
        title: '首页',
        name: 'home',
        component: resolve => {
          require(['@/view/home/home.vue'], resolve)
        }
      },
      {
        path: 'navigator',
        title: '导航',
        name: 'navigator',
        component: resolve => {
          require(['@/view/home/navigator.vue'], resolve)
        }
      }
    ]
  }
]

export const MainRoute = [
  loginRouter,
  passwordRouter,
  podTerminal,
  appTerminal,
  podLog,
  appLog,
  nodeTerminal,
  creplay,
  ...appRouter,
  page401
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js